<div class="flex w-full gap-1 items-start {{ flex_direction }}"> 
    @if (label) {
        <label class="font-bold text-black">{{ label }}</label>
    }

    <p-toggleButton
        class="w-full"
        [onLabel]="onLabel"
        [offLabel]="offLabel"
        [disabled]="isReadOnly"
        [(ngModel)]="value"
        (onChange)="changeValue($event)"
        [pt]="{
            root: {
                class: 'w-full h-8 [&.p-togglebutton-checked]:!bg-primary [&.p-togglebutton-checked]:!border-primary [&.p-togglebutton-checked]:!text-white [&.p-togglebutton-checked_.p-togglebutton-content]:!bg-transparent [&.p-togglebutton-checked_.p-togglebutton-content]:!shadow-none [&.p-togglebutton-checked_.p-togglebutton-label]:!text-white',
            },
        }"
    ></p-toggleButton>
</div>
